import serverVars from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';
import { trackingConstants } from 'dibs-tracking';

const isUserTypeTrade = serverVars.get('settings.isUserTypeTrade');
const KEY_SESSION_MODAL_COUNT = 'sessionModalCount';
const KEY_SESSION_MODAL_LAST_SHOWN_PAGE = 'modalLastShownPage';
const TRADE_MODAL_CAP = 5;
const TRADE_MODAL_INBETWEEN_PAGE_MINIMUM = 3;
const pageModalLastShown = sessionStorage.getItem(KEY_SESSION_MODAL_LAST_SHOWN_PAGE) || 0;
const modalViewCount = sessionStorage.getItem(KEY_SESSION_MODAL_COUNT) || 0;

/**
For Trade users, notifictions should show up under the following conditions:
    If Notification Count >= Cap, then do NOT show notification
    If Notification Count = 0, then SHOW notification
    If (0 < Notification Count < Cap), check Pageview count between notifications
    If Pageview Count >= Minimum Pageview count required, then SHOW notification
    If Pageview Count < Minimum Pageview count required, then do NOT show notification
The current cap is set to 5 by TRADE_MODAL_CAP and the pageview requirement
is set to 3 by TRADE_MODAL_INBETWEEN_PAGE_MINIMUM.

For Non-Trade users, this rule should always return true.
*/
export const shouldSkipNotifForTrade = () => {
    if (isUserTypeTrade) {
        const pageViewCount = sessionStorage.getItem(trackingConstants.KEY_SESSION_PAGE_COUNT) || 1;
        if (modalViewCount > TRADE_MODAL_CAP) {
            return true;
        } else if (modalViewCount === 0) {
            return false;
        } else {
            return pageViewCount - pageModalLastShown > TRADE_MODAL_INBETWEEN_PAGE_MINIMUM;
        }
    }

    return false;
};

export const incrementTradeNotifStorage = () => {
    if (isUserTypeTrade) {
        const onPage = sessionStorage.getItem(trackingConstants.KEY_SESSION_PAGE_COUNT) || 1;
        sessionStorage.setItem(KEY_SESSION_MODAL_COUNT, modalViewCount + 1);
        sessionStorage.setItem(KEY_SESSION_MODAL_LAST_SHOWN_PAGE, onPage);
    }
};
